import React, { useState } from 'react';
import { ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Eye, Trash, PencilSquare } from 'react-bootstrap-icons';
import XLSX from 'sheetjs-style';
import moment from 'moment';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import 'assets/css/table.css';
import dateformat from 'dateformat';
import common from '../../../commonData';
import NavMenuReglement from './navbar-reglement';
import Axios from 'axios';
// import FactureMultiple from './factureMultiple';
// import NavMenuFact from './navbar-fact';

function FactureGrid({ rows, setListeReglement, isLoading, setIsLoad, setAddReglement, setMsg, setMsgravity, setIsSave }) {
    window.moment = moment;
    const [gridRef, setGridRef] = useState(null);
    const [selected, setSelected] = useState(new Set());
    const [showFact, setShowFact] = useState(false);
    function numberformat(data) {
        return new Intl.NumberFormat().format(data);
    }

    const filterValueFact = [
        { name: 'raisonfrs', operator: 'contains', type: 'string', value: '' },
        { name: 'date_regl', operator: 'inrange', type: 'date', value: '' },
        { name: 'username', operator: 'contains', type: 'string', value: '' },
        { name: 'useru', operator: 'contains', type: 'string', value: '' },
        { name: 'norecu', operator: 'contains', type: 'string', value: '' },
        { name: 'created_at', operator: 'inrange', type: 'date', value: '' },
        { name: 'updated_at', operator: 'inrange', type: 'date', value: '' },
        { name: 'montantimput', operator: 'gte', type: 'number', value: 0 },
        { name: 'montant', operator: 'gte', type: 'number', value: 0 },
        { name: 'nocheq', operator: 'contains', type: 'string', value: '' },
        { name: 'type_reglement', operator: 'contains', type: 'string', value: '' },
        { name: 'nocheq', operator: 'contains', type: 'string', value: '' }
    ];

    const columnsfact = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 65,
            type: 'number'
        },
        {
            header: 'Action',
            defaultWidth: 110,
            type: 'string',
            render: ({ value, data }) => {
                return (
                    <div className="menudrops">
                        <ButtonGroup aria-label="Basic example">
                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> Voir détail</Tooltip>}>
                                <a href="#/admin/achats">
                                    <Eye color="royalblue" size={25} />
                                </a>
                            </OverlayTrigger>
                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> Modifier</Tooltip>}>
                                <a href="#/admin/achats" onClick={() => setAddReglement(data.id)}>
                                    <PencilSquare color="blue" size={25} />
                                </a>
                            </OverlayTrigger>
                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> Supprimer</Tooltip>}>
                                <a href="#/admin/achats" onClick={() => onDelete(data.id)}>
                                    <Trash color="red" size={25} />
                                </a>
                            </OverlayTrigger>
                        </ButtonGroup>
                    </div>
                );
            }
        },
        {
            name: 'norecu',
            header: 'N° reçu',
            defaultWidth: 100,
            type: 'string'
        },
        {
            name: 'raisonfrs',
            header: 'Fournisseurs',
            defaultWidth: 200,
            type: 'string'
        },
        {
            name: 'montant',
            header: 'Mont. règlement',
            defaultWidth: 100,
            type: 'number',
            textAlign: 'center',
            render: ({ value }) => numberformat(value ?? 0)
        },
        {
            name: 'montantimput',
            header: 'Mont. imputé',
            defaultWidth: 100,
            type: 'number',
            textAlign: 'center',
            render: ({ value }) => numberformat(value ?? 0)
        },
        {
            name: 'type_reglement',
            header: 'Type règlement',
            defaultWidth: 150,
            type: 'string'
        },
        { name: 'nocheq', header: 'N° chèque', defaultWidth: 150, type: 'string' },
        {
            name: 'date_regl',
            header: 'Date reglement',
            defaultWidth: 200,
            type: 'date',
            dateFormat: 'DD-MM-YYYY',
            textAlign: 'center',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                // for range and notinrange operators, the index is 1 for the after field
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date debut'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => moment(value).format(dateFormat)
        },

        { name: 'username', header: 'Crée par', defaultWidth: 100, type: 'string' },
        {
            name: 'created_at',
            header: 'Crée le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        },
        { name: 'useru', header: 'Modif. par', defaultWidth: 100, type: 'string' },
        {
            name: 'updated_at',
            header: 'Modif. le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformat(value, 'dd-mm-yyyy HH:MM')
        }
    ];

    function onDelete(id) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SEE');
        if (log == undefined) {
            if (log1 == undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        if (window.confirm('Voulez-vous supprimer cette ligne?')) {
            setIsLoad(true);
            Axios.delete(common.ipapi + '/api/reglementfrs/destroy/' + id).then((response) => {
                if (response.data.status === 1) {
                    const del = rows.filter((d) => d.id !== id);
                    setListeReglement(del);
                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setIsLoad(false);
                } else {
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setMsgravity('danger');
                    setIsLoad(false);
                }
            });
        }
    }

    const setFacts = (id) => {
        if (id !== 0) {
            setSelected(id);
        }
        setShowFact(true);
    };
    const gridStyle = { minHeight: window.screen.height - 200 };

    //--------------- EXPORT VERS EXCEL ------------------
    const exportCSV = () => {
        const data = [];
        var montantverse = 0;
        var montantimput = 0;
        const raw_data = [...gridRef.current.data.sort(GetSortOrder('date_regl'))];
        /* flatten objects */
        raw_data.forEach((row) => {
            montantverse += row.montant;
            montantimput += row.montantimput;
            data.push({
                norecu: row.norecu || 'Néant',
                fournisseur: row.raisonfrs || 'Néant',
                montant: row.montant,
                montantimput: row.montantimput,
                reste: row.montant - row.montantimput,
                type_reglement: row.type_reglement,
                nocheq: row.nocheq || 'Néant',
                date: dateformat(row.date_regl, 'dd-mm-yyyy')
            });
        });

        data.push({
            norecu: '',
            fournisseur: '',
            montant: montantverse,
            montantimput: montantimput,
            reste: montantverse - montantimput,
            type_reglement: '',
            nocheq: '',
            date: ''
        });
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes reglements fournisseurs');
        /* fix headers */
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [['norecu', 'fournisseur', 'montant reglement', 'montant imput.', 'reste à imputer', 'type_reglement', 'nocheq', 'date']],
            {
                origin: 'A1'
            }
        );
        /* calculate column width */
        const max_width = data.reduce((w, r) => Math.max(w, r.norecu.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'reglement-fournisseur.xlsx');
    };

    const SEPARATOR = ',';

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    }
    //-------------IMPRIMER LES LISTE ----------------
    function printListe() {
        const raw_data = [...gridRef.current.data.sort(GetSortOrder('raisonfrs'))];
        if (gridRef.current.data.length <= 0) {
            setMsg('Aucune donnée à imprimer');
            setIsSave(true);
            setMsgravity('danger');
            return;
        }
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        var width = doc.internal.pageSize.getWidth();
        const data = [];
        doc.text(common.libsociete.toUpperCase(), 90, 14);
        doc.setFontSize(12);
        doc.setFillColor(0, 0, 0);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.text('LISTE DES REGLEMENTS FOURNISSEURS', 90, 22);
        doc.setTextColor(0, 0, 0);
        var montantverse = 0;
        var montantimput = 0;
        /* flatten objects */
        raw_data.forEach((row) => {
            montantverse += row.montant;
            montantimput += row.montantimput;
            data.push([
                { content: row.norecu || 'Néant' },
                { content: row.raisonfrs || 'Néant' },
                { content: row.montant },
                { content: row.montantimput },
                { content: row.montant - row.montantimput },
                { content: row.type_reglement },
                { content: row.nocheq || 'Néant' },
                { content: dateformat(row.date_regl, 'dd-mm-yyyy') }
            ]);
        });
        data.push([
            { content: 'TOTAL', colSpan: 2, styles: { fontStyle: 'bold', fontSize: 12 } },
            { content: new Intl.NumberFormat('de-DE').format(montantverse), styles: { fontStyle: 'bold', fontSize: 12 } },
            { content: new Intl.NumberFormat('de-DE').format(montantimput), styles: { fontStyle: 'bold', fontSize: 12 } },
            {
                content: new Intl.NumberFormat('de-DE').format(montantverse - montantimput),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            '',
            '',
            ''
        ]);
        doc.autoTable({
            styles: {
                fillColor: [206, 206, 206],
                textColor: [4, 4, 4],
                halign: 'center',
                fontSize: 10,
                cellPadding: 0.75
            },
            columnStyles: {
                0: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    // cellWidth: 15,
                    fontSize: 8
                },
                1: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                2: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                3: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                4: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                5: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                6: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                7: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                }
            },
            theme: 'grid',
            startY: 35,
            fontSize: 6,
            head: [
                [
                    'N° recu',
                    'Fournisseur',
                    'Montant reglement',
                    'Montant imput.',
                    'Reste à imputer',
                    'Type_reglement',
                    'N° cheque/vir.',
                    'Date'
                ]
            ],
            body: data
        });
        const pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text('Page ' + String(i) + ' sur ' + String(pageCount), 210 - 55, 200, null, null, 'right');
        }
        doc.save('reglement-fournisseur.pdf');
    }
    const HandleonSelectionChange = ({ selected }) => {
        setSelected(selected);
        // console.log('Sélection actuelle :', selected);
    };
    const toArray = (selected, dataMap) => {
        const keysObj = selected === true ? dataMap : selected;
        return Object.keys(keysObj).map((key) => Number(key));
    };
    const dataMap = gridRef && gridRef.current && gridRef.current.dataMap ? gridRef.current.dataMap : null;

    return (
        <div>
            <NavMenuReglement
                printListe={printListe}
                setAddReglement={setAddReglement}
                exportCSV={exportCSV}
                selected={JSON.stringify(toArray(selected, dataMap))}
                setFacts={setFacts}
            />
            <ReactDataGrid
                idProperty="id"
                handle={setGridRef}
                style={gridStyle}
                selected={selected}
                loading={isLoading}
                reorderColumns={false}
                pagination
                pageSizes={[200, 400, 600, 800, 1000]}
                defaultLimit={400}
                showHoverRows={true}
                editable={true}
                showColumnMenuTool={false}
                defaultFilterValue={filterValueFact}
                columns={columnsfact}
                dataSource={rows}
                onSelectionChange={HandleonSelectionChange}
            />
        </div>
    );
}

export default FactureGrid;
